"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  KeepAwake: () => KeepAwake,
  useKeepAwake: () => useKeepAwake
});
module.exports = __toCommonJS(index_native_exports);
var import_react = require("react");
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_validate = require("./validate");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneKeepAwake");
  return hybrid;
}
function isEnabled() {
  return native().isEnabled().catch(import_nativeError.rethrowNativeError);
}
function setEnabled(enabled) {
  (0, import_validate.assertKeepAwakeEnabled)(enabled);
  return native().setEnabled(enabled).catch(import_nativeError.rethrowNativeError);
}
function activate(tag) {
  (0, import_validate.assertKeepAwakeTag)(tag, "activate");
  return native().activate((0, import_validate.normalizeKeepAwakeTag)(tag)).catch(import_nativeError.rethrowNativeError);
}
function deactivate(tag) {
  (0, import_validate.assertKeepAwakeTag)(tag, "deactivate");
  return native().deactivate((0, import_validate.normalizeKeepAwakeTag)(tag)).catch(import_nativeError.rethrowNativeError);
}
function useKeepAwake(tag) {
  var fallback = (0, import_react.useId)();
  (0, import_validate.assertKeepAwakeTag)(tag, "useKeepAwake");
  var effective = tag !== null && tag !== void 0 ? tag : fallback;
  (0, import_react.useEffect)(function() {
    activate(effective).catch(function(error) {
      console.error(`Failed to keep the screen awake: ${String(error)}`);
    });
    return function() {
      deactivate(effective).catch(function() {
      });
    };
  }, [
    effective
  ]);
}
var KeepAwake = Object.freeze({
  isEnabled,
  setEnabled,
  activate,
  deactivate
});
//# sourceMappingURL=index.native.js.map
